export const TIMEZONE = import.meta.env.VITE_APP_TIMEZONE || 'Europe/Rome'

export const BOOKING = {
  CUTOFF_HOUR: 19,
  NEXT_DAY_CUTOFF_HOUR: 9,
  NEXT_DAY_MIN_HOUR: 11,
  HOURLY_DURATIONS: [2, 3, 4, 5, 6, 7, 8, 9, 10]
}

export const PAGINATION = {
  PER_PAGE: 10
}
